
@if ({row: columnData | async,adata: additionData | async}; as $) {
  @if ($.row && $.row.is_ewallet_deposit && $.row.is_ewallet_deposit == true) {
    <div class="flex align-items-center">
      <i class="fa fa-wallet mr-2"></i>  {{'INVOICE.COLUMNS.E_WALLET' | translate}}
    </div>
  } @else {
    @if (($.adata.type == getPdfType.Invoice || $.adata.type.toString() == getPdfType[getPdfType.Invoice]) && $.row.invoiceNumbers && $.row.invoiceNumbers.length > 0) {
      <div>
        @for (invoice of $.row.invoiceNumbers; track invoice) {
          <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata,invoice)" >{{invoice}}</a>
        }
      </div>
    } @else {
      <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata,$.row[$.adata.fetch_key])" >{{$.row[$.adata.fetch_key]}}</a>
      @if (($.adata.type == getPdfType.Payment || $.adata.type.toString() == getPdfType[getPdfType.Payment])) {
        @if ($.row.is_online) {
          <i class="fa fa-globe text-sm ml-1 cursor-pointer" pTooltip="This is an Online Payment" tooltipPosition="top" aria-label="online-payment-indicator"></i>
        }
        <span  [pTooltip]="" tooltipStyleClass="text-xs" class="ml-2 w-1rem">
          @if ($.row.settlement_id && $.row.settlement_id !== '') {
            <img width="20" src="assets/img/icons/double-check.png" alt="Icon" [pTooltip]="'Settlement'" >
          }
          @if ($.row.dispute_status && $.row.dispute_status !== 'None') {
            <img width="20" src="assets/img/icons/cart-error.png" alt="Icon" [pTooltip]="'Dispute'">
          }
        </span>
      }
    }
  }
  <!-- <ng-template #prefix>
  <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata)" >{{$.row[$.adata.fetch_key]}}</a>
</ng-template> -->
}